/* Zahlungsart-Radio-Cards (snippets/pdp-payment-choice.liquid, in TN-Box und Hero).
   Umschaltstelle für Selbstzahler <-> Gefördert:
   - liest beim Laden ?payment=gefoerdert (ohne Parameter: Selbstzahler),
   - setzt data-payment am .pdp-hero und hält den URL-Parameter per replaceState synchron,
   - hält beide Radio-Gruppen (Box/Hero) auf demselben Wert,
   - feuert pdp:payment-changed, woran Hero-/Box-Bereiche per CSS und andere Sections andocken. */
(function () {
  "use strict";

  var PARAM = "payment";
  var FUNDED = "gefoerdert";
  var SELF = "selbstzahler";

  var hero = document.querySelector(".pdp-hero");
  if (!hero) return;

  var inputs = hero.querySelectorAll(
    "[data-payment-choice] input[type='radio']",
  );
  if (!inputs.length) return;

  function setPayment(value, syncUrl) {
    inputs.forEach(function (input) {
      input.checked = input.value === value;
    });

    hero.setAttribute("data-payment", value);

    if (syncUrl) {
      var url = new URL(window.location.href);
      if (value === FUNDED) {
        url.searchParams.set(PARAM, FUNDED);
      } else {
        url.searchParams.delete(PARAM);
      }
      history.replaceState(history.state, "", url);
    }

    document.dispatchEvent(
      new CustomEvent("pdp:payment-changed", { detail: { payment: value } }),
    );
  }

  inputs.forEach(function (input) {
    input.addEventListener("change", function () {
      if (input.checked) setPayment(input.value, true);
    });
  });

  var initial =
    new URLSearchParams(window.location.search).get(PARAM) === FUNDED
      ? FUNDED
      : SELF;
  setPayment(initial, false);

  /* Unterhalb 1024px ist die TN-Box ein Dialog. Damit das Beratungsformular im
     Gefördert-Modus wie auf Desktop sichtbar ist, wandert der Lead-Block dann in den
     Hero-Platzhalter und bei breiten Viewports zurück an seine Stelle im Dialog. */
  var fundedBlock = document.querySelector("#TN-Form-Dialog .TN-Form-Funded");
  var inlineTarget = hero.querySelector("[data-funded-inline]");
  if (fundedBlock && inlineTarget) {
    var dialogParent = fundedBlock.parentNode;
    var dialogAnchor = fundedBlock.nextSibling;
    var narrow = window.matchMedia("(max-width: 1023px)");

    function placeFundedBlock() {
      if (narrow.matches) {
        if (fundedBlock.parentNode !== inlineTarget)
          inlineTarget.appendChild(fundedBlock);
      } else if (fundedBlock.parentNode !== dialogParent) {
        dialogParent.insertBefore(fundedBlock, dialogAnchor);
      }
    }

    placeFundedBlock();
    if (typeof narrow.addEventListener === "function") {
      narrow.addEventListener("change", placeFundedBlock);
    } else {
      narrow.addListener(placeFundedBlock);
    }
  }
})();
